import { render, staticRenderFns } from "./viewProduct.vue?vue&type=template&id=3768f70c&scoped=true&"
import script from "./viewProduct.vue?vue&type=script&lang=js&"
export * from "./viewProduct.vue?vue&type=script&lang=js&"
import style0 from "./viewProduct.vue?vue&type=style&index=0&id=3768f70c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3768f70c",
  null
  
)

export default component.exports